import { supabase } from '../lib/supabaseClient';

/**
 * Mengambil data halaman publik secara aman.
 * - Hanya halaman dengan status = published
 * - Section otomatis diurutkan & hanya yang aktif
 * - Aman untuk SEO (title + description)
 * Return null jika data tidak ada atau terjadi error.
 */
export async function getPublishedPage(slug: string = 'home') {
  try {
    const { data, error } = await supabase
      .from('cms_pages')
      .select(
        `
        id,
        slug,
        title,
        description,
        status,
        cms_sections (
          id,
          type,
          content,
          position,
          is_active
        )
      `
      )
      .eq('slug', slug)
      .eq('status', 'published')
      .order('position', { foreignTable: 'cms_sections' })
      .maybeSingle();

    if (error) {
      /* console removed */
      return null;
    }

    if (!data) {
      return null;
    }

    // Pastikan hanya section aktif yang dipakai
    if (Array.isArray(data.cms_sections)) {
      data.cms_sections = data.cms_sections.filter((section: any) => section.is_active === true);
    }

    return data;
  } catch (err: any) {
    /* console removed */
    return null;
  }
}
